// States y Hooks (estados y ganchos de un componente)
// El componente Form no va a heredar el nombre de la tarea de App, el elemento input esta aqui asi que Form es el responsable de crear los nombres de las tareas.
// El componente Form va a buscar en sus propios datos, a estos se les llama ESTADOS, el componente no solo posee estados sino puede editarlos despues
// La diferencia de los props y los estados es que un componente que recibe un prop solo puede leerlo, un estado que posee un componente puede leerse y editarse
// Las funciones que permiten manipular los estados de un componente se llaman GANCHOS
// useState es un gancho que permite convertir un dato de un componente en estado, la funcion devuelve el estado y una funcion para editarlo
import React, {useState} from "react";

// Declarar y exportar el componente al mismo tiempo
export default function Form(props) {
    // Toma un dato y devuelve arreglo con el estado y funcion para editarlo, se usa destructuring para almacenarlo en variables separadas
    const [nombre, editarNombre] = useState("");

    // Para detectar cambios en el imput
    function change(e) {
        // A medida que cambien los valores, la funcion para editar el estado va cambiando el valor del mismo estado (nombre)
        editarNombre(e.target.value);
    };

    // Maneja el envio del form, utiliza la funcion que se mandó como prop de App para devolver lo introducido en el input como el nombre de la tarea
    function submit(e) {
        e.preventDefault();
        props.agregarTarea(nombre);
        // Despues del envio del parametro a la funcion de App se limpia el input
        editarNombre("");
    };
      
    return (
        // Al ser enviado el form, ejecuta la funcion submit
        <form onSubmit = {submit}>
            <h3 className = "label-wrapper">
                <label htmlFor = "new-todo-input" className = "label__lg">¿Que tareas debes hacer?</label>
            </h3>

            {/* El valor del input es el estado (nombre) del componente Form */}
            {/* Al escribir el usuario, se ejecuta la funcion change */}
            <input type = "text" id = "new-todo-input" className = "input input__lg" name = "text" autoComplete = "off" value = {nombre} onChange = {change} placeholder = "Ej: Ir a la farmacia" required />

            <button type = "submit" className = "btn btn__primary btn__lg">Agregar</button>
        </form>
    );
}  